import { faCog, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'
import { faToolbox } from '@fortawesome/free-solid-svg-icons'
import React from 'react'
import { useSelector } from 'react-redux'
import { isAdmin } from '../../session'
import { IStoreState } from '../../store'
import { Navigator } from 'ui/Templates'

export const ProfileNav: React.FC = () => {
  const admin = useSelector<IStoreState>((state) => isAdmin(state.session))
  return (
    <Navigator.Drawer relative={true} name="Settings">
      {admin ? (
        <Navigator.Item to="/admin" label="Admin Tools" icon={faToolbox} />
      ) : null}
      <Navigator.Item to="/app/settings" label="Settings" icon={faCog} />
      <Navigator.Item to="/app/logout" label="Logout" icon={faSignOutAlt} />
    </Navigator.Drawer>
  )
}
